<template>
  <div class="sales-panel container-fluid h-100 w-100">
    <!-- Header Section -->
    <b class="m-2" v-if="customer" :style="{color: 'var(--text-primary)'}">Customer : {{ customer.name }}</b>

    <!-- Customer Information -->
    <div v-if="showHeader" class="container d-flex float-row align-items-center sale-header card-base">
      <div class="row header">
        <button v-if="showBack"
                @click="close"
                class="rounded-circle bg-transparent m-1 btn-secondary-lightning">
          <font-awesome-icon icon="fa-solid fa-arrow-left" :style="{color: 'var(--text-primary)'}"></font-awesome-icon>
        </button>
      </div>

      <!-- New Buttons -->
      <button id="openCustomerInformationModalButton" class="btn btn-primary d-none" data-bs-toggle="modal"
              data-bs-target="#amountInputModal">Open Amount Input Modal
      </button>
      <button id="openAmountInputModalButton" class="btn btn-primary d-none" data-bs-toggle="modal"
              data-bs-target="#customerInfoModal">Open Customer Information Modal
      </button>

      <!-- Modals -->
      <!-- Modal for Amount Input -->
      <div class="modal fade" id="amountInputModal" tabindex="-1" aria-labelledby="amountInputModalLabel"
           aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content card-base">
            <div class="modal-header">
              <h5 class="modal-title" id="amountInputModalLabel" :style="{color: 'var(--text-primary)'}">Enter Amount</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label for="customerPhoneNumber" class="form-label" :style="{color: 'var(--text-secondary)'}">cell Number</label>
                <input type="tel" class="form-control" id="customerPhoneNumber" v-model="cell" min="10" maxlength="10"
                       placeholder="Enter phone number" required>
              </div>
              <div class="mb-3">
                <label for="cell" class="form-label" :style="{color: 'var(--text-secondary)'}">Amount</label>
                <input type="number" class="form-control" id="cell" v-model="amount" placeholder="Enter amount"
                       required>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-secondary-lightning" id="amountCloseBtn" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary btn-primary-lightning" @click="handleAmountInputSave">Save</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal for Customer Information -->
      <div class="modal fade" id="customerInfoModal" tabindex="-1" @hidden.bs.modal="resetCustomerInfoFields"
           aria-labelledby="customerInfoModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content card-base">
            <div class="modal-header">
              <h5 class="modal-title" id="customerInfoModalLabel" :style="{color: 'var(--text-primary)'}">Enter Customer Information</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label for="phoneNumber" class="form-label" :style="{color: 'var(--text-secondary)'}">cell Number</label>
                <input type="tel" class="form-control" id="phoneNumber" maxlength="10" v-model="cell"
                       placeholder="Enter phone number" required>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-secondary-lightning" id="closemodal" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary btn-primary-lightning" @click="handleCustomerInfoSave">Save</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal for Voucher Purchasing Screen -->
      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
          <div class="modal-content card-base">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel" :style="{color: 'var(--text-primary)'}">Voucher Purchasing Screen</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body" style="max-height: 75vh; overflow-y: auto;">
              <div class="row">
                <!-- Left side: existing design -->
                <div class="col-md-4">
                  <div class="list-group">
                    <a class="list-group-item list-group-item-action" v-for="(option, index) in options" :key="index"
                       @click="selectOption(option)" :style="{background: 'var(--card-bg)', color: 'var(--text-primary)', borderColor: 'var(--card-border)'}">
                      {{ option }}
                    </a>
                  </div>
                </div>
                <!-- Right side: list of other clickable options -->
                <div class="col-md-8">
                  <div class="product-card card-base" v-for="item in selectedItem" :key="item.PLU" @click="checkItemOffer(item)">
                    <div class="stock-card_img mx-2 mt-2" v-if="item.Image">
                      <img :src="item.Image" alt="Item Image">
                    </div>
                    <div class="card-body mx-3 p-1 d-flex justify-content-between flex-column">
                      <span class="text-secondary text-sm">Stock Code : {{ item.PLU }}</span>
                      <h6 class="product-description">
                        {{ item.Description }} <br>
                        <span class="product-description2">{{ item.Description2 }}</span>
                      </h6>
                      <h5 class="product-price">{{ $utils.formatMoney(item.SellingIncl) }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-secondary-lightning" id="closebutton" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>


      <span class="badge bg-info m-2" v-if="tipAmount > 0" :style="{background: 'var(--accent-electric-blue)', color: 'var(--text-primary)'}">Tip : {{ $utils.formatMoney(tipAmount) }}</span>
    </div>

    <!-- Sale Lines Table -->
    <div ref="saleLinesTable" class="sale-lines-table card-base">
      <div class="sales-list-header">
        <div class="header-cell stock-code-header">Stock Code</div>
        <div class="header-cell description-header">Description</div>
        <div class="header-cell tax-header">Tax Label</div>
        <div class="header-cell qty-header">Qty</div>
        <div class="header-cell discount-header">Discount</div>
        <div class="header-cell unit-price-header">Unit Price</div>
        <div class="header-cell total-price-header">Total</div>
      </div>
      
      <DynamicScroller
        ref="saleLinesScroller"
        class="scroller"
        :items="currentSaleLines"
        :min-item-size="36"
        key-field="index"
      >
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem
            :item="item"
            :active="active"
            :size-dependencies="[
              item.Description,
              item.instructions,
            ]"
            :data-index="index"
          >
            <CurrentSaleLine
              :sale-line="item"
              :is-selected="selectedSaleLine && selectedSaleLine.index === item.index"
              @select-line="selectLine"
              @increase-qty-line="addQtyForLine"
              @decrease-qty-line="reduceQtyForLine"
            />
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>
      <FloatingButtons
        :is-disabled="isDisabled"
        :customer="customer"
        :route-name="routeName"
        :selected-sale-line="selectedSaleLine"
        :current-sale-lines="currentSaleLines"
        @unselect-customer="unselectCustomer"
        @select-customer="selectCustomer"
        @void-selected-line="voidSelectedLine"
        @add-qty-selected-line="addQtySelectedLine"
        @reduce-qty-selected-line="reduceQtySelectedLine"
        @apply-discount-selected-line="applyDiscountSelectedLine"
        @move-selection-up="moveSelectionUp"
        @move-selection-down="moveSelectionDown"
        @set-quantity="setQuantity"
        @read-from-scale="readFromScaleForSelected"
      />
    </div>

    <!-- Sale Stats -->
    <div class="sale-stats card-base">
      <OpenTableName />

      <SaleDetails/>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import CurrentSaleLine from "@/components/point-of-sale/sales/CurrentSaleLine";
import SaleDetails from "@/components/point-of-sale/sales/SaleDetails";
import OpenTableName from "@/components/point-of-sale/table/OpenTableName.vue";
import FloatingButtons from "@/components/layout/utils/FloatingButtons.vue";
import scaleService from "@/services/scaleService";
import LedService from "@/services/ledService";
import LedConfig from "@/services/LedConfig";
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

export default {
  watch: {
    // Watch the array reference. Fires when Vuex replaces the array
    // (e.g. addToCurrentSaleLines commits a new array). Paired with
    // the line-count watcher below to also catch in-place mutations
    // (e.g. push/splice) that don't replace the array reference.
    '$store.state.sales.currentSaleLines': {
      /**
       * @param {Array} newValue - New sale-lines array from the Vuex store
       * @description Debounces a scroll-to-bottom + a localStorage save. The
       * scroll only happens when the line count actually grew or the user is
       * near the bottom (the near-bottom guard is inside scrollToBottom()).
       */
      handler(newValue) {
        this._scheduleScrollAndSave(newValue);
      },
      deep: false,
      immediate: false
    },
    // Secondary source: fires whenever the line count changes, including
    // in-place mutations. Guarantees the scroller responds to additions
    // even if the Vuex mutation does not replace the array reference.
    currentSaleLinesCount: {
      /**
       * @param {number} newCount - Updated number of sale lines
       * @param {number} oldCount - Previous number of sale lines
       * @description Re-runs the scroll/save debounce on any count change so
       * newly added lines are always brought into view.
       */
      handler(newCount, oldCount) {
        this._scheduleScrollAndSave(this.$store.getters.getSaleLines, newCount, oldCount);
      }
    },
    '$store.getters.isHydrated': {
      handler(isHydrated) {
        if (isHydrated) {
          // Load sale lines after store is hydrated
          this.loadSaleLinesFromStorage();
        }
      },
      immediate: true
    }
  },
  name: "CurrentSaleTable",
  components: {
    SaleDetails,
    CurrentSaleLine,
    OpenTableName,
    FloatingButtons,
    DynamicScroller,
    DynamicScrollerItem
  },
  props: {
    showHeader: {
      type: Boolean,
      required: false,
      default: true
    },
    showBack: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      selectedCategory: null,
      selectedItem: [],
      amount: '', // Bind to Amount input
      cell: '', // Bind to Phone Number input
      amountPaid: '', // Bind to Amount Paid input
      currentItem: null, // To track the currently selected item
      selectedSaleLine: null,
      _cachedCustomer: null,
    };
  },
  computed: {
    tipAmount() {
      return this.$store.getters.getTipAmount;
    },
    options() {
      return this.$store.getters.getZedMobileCategories;
    },
    customer() {
      const id = this.$store.getters.getCustomer;
      if (!id) return this._cachedCustomer?.id === id ? this._cachedCustomer : null;
      const customerName = this.$store.getters.getDebtorByID(id);
      if (this._cachedCustomer?.id === id && this._cachedCustomer?.name === customerName) {
        return this._cachedCustomer;
      }
      this._cachedCustomer = { id, name: customerName };
      return this._cachedCustomer;
    },
    currentSaleLines() {
      // Direct access to store getters - removing the O(N) map operation
      return this.$store.getters.getSaleLines;
    },
    /**
     * Number of sale lines in the current sale. Used as a secondary
     * watcher source so the auto-scroll fires on in-place mutations
     * (e.g. push/splice on the underlying array) that would not trigger
     * a reference change in the store array.
     * @returns {number}
     */
    currentSaleLinesCount() {
      const lines = this.$store.getters.getSaleLines;
      return Array.isArray(lines) ? lines.length : 0;
    },
    isDisabled() {
      const lines = this.$store.getters.getSaleLines;
      // Optimization: use simple loop or some()
      return lines && lines.some(line => line.Qty <= 0);
    },
    zedMobileStatus() {
      return this.$store.getters.getZedMobileStatus;
    },
    routeName() {
      return this.$route.name;
    }
  },
  created() {
    // Initialize currentSaleLines from localStorage if it exists
    this.loadSaleLinesFromStorage();
  },

  mounted() {
    // Ensure sale lines are loaded after component is mounted
    this.$nextTick(() => {
      this.loadSaleLinesFromStorage();
    });
  },

  beforeDestroy() {
    // Cleanup timers to prevent memory leaks
    if (this._scrollTimeout) {
      clearTimeout(this._scrollTimeout);
    }
    if (this._saveTimeout) {
      clearTimeout(this._saveTimeout);
    }
    
    // Save currentSaleLines to localStorage before component is destroyed
    localStorage.setItem('currentSaleLines', JSON.stringify(this.$store.getters.getSaleLines));
  },
  methods: {
    normalizeBool(value) {
      return value === true || value === 1 || value === '1' || value === 'true';
    },
    getLedBroadcastOptions() {
      const ledSettings = LedConfig.getEffective(this.$store.getters.getDeviceSettings || this.$store.state.settings || {});
      return {
        enabled: this.normalizeBool(ledSettings?.enableLedDisplay),
        port: ledSettings?.ledPort || 'COM2',
        baudRate: Number(ledSettings?.ledBaudRate || 2400) || 2400,
      };
    },
    getSaleLineDisplayTotal(line) {
      if (!line) return 0;
      const qty = Number(line.Qty) || 0;
      const unit = Number(line.Unit) || 0;
      const tourismLevy = Number(line.tourismLevy || 0);
      const discount = Number(line.Discount || 0);
      const instructionTotal = Array.isArray(line.instructions)
        ? line.instructions.reduce((sum, item) => sum + (Number(item.Price || 0) * Number(item.count || item.Qty || 1)), 0)
        : 0;
      return Number(((qty * unit) + (qty * tourismLevy) + instructionTotal - discount).toFixed(2));
    },
    getCurrentSaleDisplayTotal() {
      return (this.currentSaleLines || []).reduce((sum, line) => sum + this.getSaleLineDisplayTotal(line), 0);
    },
    async broadcastCurrentSaleTotalToLed(reason = 'sale-total') {
      const { enabled, port, baudRate } = this.getLedBroadcastOptions();
      if (!enabled) {
        console.log(`[LED] ${reason} skipped: LED display disabled in settings`);
        return;
      }
      if (!LedService.isAvailable()) {
        console.log(`[LED] ${reason} skipped: ledDisplay bridge unavailable`);
        return;
      }
      const total = this.getCurrentSaleDisplayTotal();
      console.log('[LED] Broadcasting current sale total from CurrentSaleTable', {
        reason,
        total: total.toFixed(2),
        port,
        baudRate,
      });
      await LedService.showTotal(total, { port, baudRate });
    },
    async broadcastSelectedLineToLed(line) {
      const { enabled, port, baudRate } = this.getLedBroadcastOptions();
      if (!enabled) {
        console.log('[LED] Selected line broadcast skipped: LED display disabled in settings');
        return;
      }
      if (!LedService.isAvailable()) {
        console.log('[LED] Selected line broadcast skipped: ledDisplay bridge unavailable');
        return;
      }
      if (!line) {
        await this.broadcastCurrentSaleTotalToLed('selected-line-missing');
        return;
      }

      const total = this.getSaleLineDisplayTotal(line);
      console.log('[LED] Broadcasting selected sale line to LED', {
        index: line.index,
        plu: line.Plu,
        description: line.Description,
        qty: Number(line.Qty) || 0,
        unit: Number(line.Unit) || 0,
        lineTotal: total.toFixed(2),
        port,
        baudRate,
      });
      await LedService.showTotal(total, { port, baudRate });
    },
    loadSaleLinesFromStorage() {
      const existingLines = this.$store.getters.getSaleLines;
      if (Array.isArray(existingLines) && existingLines.length > 0) {
        return;
      }
      const storedSaleLines = localStorage.getItem('currentSaleLines');
      if (storedSaleLines) {
        try {
          const parsedSaleLines = JSON.parse(storedSaleLines);
          if (Array.isArray(parsedSaleLines) && parsedSaleLines.length > 0) {
            // Set the sale lines in the store
            // Vue's reactivity will handle re-rendering automatically
            this.$store.commit('setCurrentLines', parsedSaleLines);
          }
        } catch (error) {
          console.error('Error parsing stored sale lines:', error);
        }
      }
    },

    async selectLine(line) {
      // Toggle selection: if clicking the same line again, deselect it
      if (this.selectedSaleLine && this.selectedSaleLine.index === line.index) {
        this.selectedSaleLine.isSelected = false;
        this.selectedSaleLine = null;
        await this.broadcastCurrentSaleTotalToLed('line-deselected');
        return;
      }
      // Clear previous selection
      if (this.selectedSaleLine) {
        this.selectedSaleLine.isSelected = false;
      }
      // Select new line
      this.selectedSaleLine = line;
      line.isSelected = true;
      await this.broadcastSelectedLineToLed(line);
    },
    moveSelectionUp() {
      if (!this.currentSaleLines.length) return;

      if (!this.selectedSaleLine) {
        // If no line is selected, select the last one
        const lastIndex = this.currentSaleLines.length - 1;
        this.selectLine(this.currentSaleLines[lastIndex]);
        this.scrollToIndex(lastIndex);
        return;
      }

      const currentIndex = this.currentSaleLines.findIndex(line => line.index === this.selectedSaleLine.index);
      if (currentIndex > 0) {
        // Select the previous line
        const nextIndex = currentIndex - 1;
        this.selectLine(this.currentSaleLines[nextIndex]);
        this.scrollToIndex(nextIndex);
      }
    },
    moveSelectionDown() {
      if (!this.currentSaleLines.length) return;

      if (!this.selectedSaleLine) {
        // If no line is selected, select the first one
        this.selectLine(this.currentSaleLines[0]);
        this.scrollToIndex(0);
        return;
      }

      const currentIndex = this.currentSaleLines.findIndex(line => line.index === this.selectedSaleLine.index);
      if (currentIndex < this.currentSaleLines.length - 1) {
        // Select the next line
        const nextIndex = currentIndex + 1;
        this.selectLine(this.currentSaleLines[nextIndex]);
        this.scrollToIndex(nextIndex);
      }
    },
    voidSelectedLine() {
      if (this.selectedSaleLine) {
        if (window && window.__comboDebug) {
          console.log('[ComboDebug] floating:void-selected-line', {
            index: this.selectedSaleLine.index,
            plu: this.selectedSaleLine.Plu,
            qty: Number(this.selectedSaleLine.Qty) || 0,
            unit: Number(this.selectedSaleLine.Unit) || 0,
            baseUnit: Number(this.selectedSaleLine.baseUnit) || 0,
            discount: Number(this.selectedSaleLine.Discount) || 0,
            specialType: this.selectedSaleLine.specialType || null,
          });
        }
        this.$store.commit('voidLine', this.selectedSaleLine);
        this.selectedSaleLine = null;
      }
    },
    async addQtyForLine(saleLine) {
      if (!saleLine) return;
      const currentQty = Number(saleLine.Qty) || 0;
      const nextQty = currentQty + 1;
      this.$store.commit('updateSaleLineQty', {
        saleLine,
        qty: nextQty
      });
      return this.$store.dispatch('calculateTipAmount');
    },
    async addQtySelectedLine() {
      return this.addQtyForLine(this.selectedSaleLine);
    },

    async askForPrice(saleLine) {
      // Create a modal to ask for the price
      const result = await Swal.fire({
        title: 'Set Price',
        input: 'number',
        inputLabel: `Enter price for ${saleLine.Description}`,
        inputValue: saleLine.Unit,
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value || parseFloat(value) <= 0) {
            return 'Please enter a valid price greater than 0';
          }
        }
      });

      if (result.isConfirmed) {
        return parseFloat(result.value);
      } else {
        // If the user cancels, return the current price
        return Number(saleLine.Unit.toFixed(2));
      }
    },
    async reduceQtyForLine(saleLine) {
      if (!saleLine) return;
      // Reducing by 1
      const result = await this.$store.dispatch('verifyAndLogQuantityVoid', {
        item: saleLine,
        quantityToVoid: 1
      });

      if (result.success) {
        this.$store.commit("reduceQuantity", saleLine);
      }
    },
    async reduceQtySelectedLine() {
      return this.reduceQtyForLine(this.selectedSaleLine);
    },
    applyDiscountSelectedLine() {
      if (this.selectedSaleLine) {
        document.getElementById(`discountCheck-${this.selectedSaleLine.index}`).click();
      }
    },
    async readFromScaleForSelected() {
        if (!this.selectedSaleLine) return;

        let port = '';
        let baud = 9600;
        let dataBits = 8;
        let parity = 'none';
        let scaleUnit = 'kg';
        let scaleUnitFromLocal = false;
        let scaleModel = 'standard';
        let scaleDecimal = 3;

        // 1. Check Local Settings
        try {
            const localSettings = localStorage.getItem('local_scale_settings');
            if (localSettings) {
                const config = JSON.parse(localSettings);
                if (config.ScalePort) port = config.ScalePort;
                if (config.ScaleBaud) baud = parseInt(config.ScaleBaud);
                if (config.ScaleDataBits) dataBits = parseInt(config.ScaleDataBits);
                if (config.ScaleParity) parity = config.ScaleParity;
                if (config.ScaleModel) scaleModel = config.ScaleModel;
                if (config.ScaleDecimal) scaleDecimal = parseInt(config.ScaleDecimal);
                if (config.ScaleUnit) {
                    scaleUnit = config.ScaleUnit;
                    scaleUnitFromLocal = true;
                }
            }

            // Check Item Stock Setting safety check
            const set = await this.$store.dispatch('getStockSetting', this.selectedSaleLine.Plu);
            if (!set || (!set.Scale && !set.scale)) {
                 window.Toast.fire({
                    icon: 'warning',
                    title: 'Item not configured for scale'
                });
                return;
            }

        } catch (e) {
            console.error('Error loading local scale settings', e);
        }

        // 2. Fallback to Global Settings
        if (!port) {
            let settings = this.$store.getters.getDeviceSettings;
            if (settings && settings.ScalePort) {
                port = settings.ScalePort;
                if (settings.ScaleBaud) baud = parseInt(settings.ScaleBaud);
                if (settings.ScaleUnit) scaleUnit = settings.ScaleUnit;
                if (settings.ScaleModel) scaleModel = settings.ScaleModel;
                if (settings.ScaleDecimal) scaleDecimal = parseInt(settings.ScaleDecimal);
            }
        }
        if (!scaleUnitFromLocal) {
            const settings = this.$store.getters.getDeviceSettings;
            if (settings && settings.ScaleUnit) {
                scaleUnit = settings.ScaleUnit;
            }
        }
        // Also get ScaleModel and ScaleDecimal from global settings if not set
        if (scaleModel === 'standard') {
            const settings = this.$store.getters.getDeviceSettings;
            if (settings && settings.ScaleModel) {
                scaleModel = settings.ScaleModel;
            }
            if (settings && settings.ScaleDecimal) {
                scaleDecimal = parseInt(settings.ScaleDecimal);
            }
        }

        console.log('[CurrentSaleTable] === FINAL SCALE SETTINGS ===');
        console.log('[CurrentSaleTable] Port:', port, '| Baud:', baud, '| Model:', scaleModel, '| Decimal:', scaleDecimal, '| Unit:', scaleUnit);
        console.log('[CurrentSaleTable] Local Scale Settings:', localStorage.getItem('local_scale_settings'));

        // 3. Default Validation
        if (!port) {
            window.Toast.fire({
                icon: 'warning',
                title: 'No Scale Port Configured'
            });
            return;
        }

        this.$utils.showLoading();
        try {
            console.log('[CurrentSaleTable] === SCALE CAPTURE START ===');
            console.log('[CurrentSaleTable] Settings - Port:', port, 'Baud:', baud, 'Model:', scaleModel, 'Decimal:', scaleDecimal, 'Unit:', scaleUnit);
            const result = await scaleService.capture(port, baud, dataBits, parity, scaleModel, scaleDecimal);
            console.log('[CurrentSaleTable] Raw Result:', JSON.stringify(result));

            if (result.ok && result.data) {
                // Parse Weight
                const weightReadings = [];
                const weightRegex = /([\d]+\.[\d]+)/;

                console.log('[CurrentSaleTable] Raw data array:', result.data);

                result.data.forEach((line, index) => {
                    console.log('[CurrentSaleTable] Processing line', index, ':', JSON.stringify(line));
                    const match = line.match(weightRegex);
                    console.log('[CurrentSaleTable] Regex match:', match);
                    if (match && match[1]) {
                        const val = parseFloat(match[1]);
                        console.log('[CurrentSaleTable] Parsed value:', val);
                        if (!isNaN(val) && val > 0) {
                            weightReadings.push(val);
                            console.log('[CurrentSaleTable] Added to weightReadings:', val);
                        }
                    }
                });

                console.log('[CurrentSaleTable] All weight readings:', weightReadings);

                if (weightReadings.length === 0) {
                    throw new Error('No valid weight detected.');
                }

                // Find Mode
                const frequency = {};
                let maxFreq = 0;
                let modeWeight = weightReadings[0];

                weightReadings.forEach(w => {
                    frequency[w] = (frequency[w] || 0) + 1;
                    if (frequency[w] > maxFreq) {
                        maxFreq = frequency[w];
                        modeWeight = w;
                    }
                });

                console.log('[CurrentSaleTable] Frequency map:', frequency);
                console.log('[CurrentSaleTable] Mode weight (before unit conversion):', modeWeight);

                if (scaleUnit === 'g') {
                    modeWeight = modeWeight / 1000;
                    console.log('[CurrentSaleTable] Converted from grams to kg:', modeWeight);
                }

                console.log('[CurrentSaleTable] Final mode weight:', modeWeight);

                // Update Quantity logic with void check
                const currentQty = this.selectedSaleLine.Qty;
                console.log('[CurrentSaleTable] Current quantity:', currentQty);

                if (modeWeight < currentQty) {
                    const diff = currentQty - modeWeight;
                    const res = await this.$store.dispatch('verifyAndLogQuantityVoid', {
                        item: this.selectedSaleLine,
                        quantityToVoid: diff
                    });

                    if (!res.success) {
                        // User cancelled or failed auth
                        return;
                    }
                }
                
                this.$store.commit('updateSaleLineQty', { 
                    saleLine: this.selectedSaleLine, 
                    qty: modeWeight 
                });
                
                window.Toast.fire({
                    icon: 'success',
                    title: `Weight: ${modeWeight} kg`
                });

            } else {
                throw new Error(result.error || 'No data received from scale.');
            }
        } catch (err) {
            console.error('Scale read error:', err);
            window.Toast.fire({
                icon: 'error',
                title: err.message
            });
        } finally {
            this.$utils.hideLoading();
        }
    },
    setQuantity() {
      if (this.selectedSaleLine) {
        // Create a modal to set the quantity
        Swal.fire({
          title: 'Set Quantity',
          input: 'number',
          inputLabel: `Current quantity: ${this.selectedSaleLine.Qty}`,
          inputValue: this.selectedSaleLine.Qty,
          showCancelButton: true,
          inputValidator: (value) => {
            if (!value || parseFloat(value) <= 0) {
              return 'Please enter a valid quantity greater than 0';
            }
          }
        }).then(async (result) => {
          if (result.isConfirmed) {
            const newQty = parseFloat(result.value);
            const currentQty = this.selectedSaleLine.Qty;
            
            if (newQty < currentQty) {
                 const diff = currentQty - newQty;
                 const res = await this.$store.dispatch('verifyAndLogQuantityVoid', {
                    item: this.selectedSaleLine,
                    quantityToVoid: diff
                 });
                 if (!res.success) return;
            }
            
            // Update the quantity
            this.$store.commit('updateSaleLineQty', { 
              saleLine: this.selectedSaleLine, 
              qty: newQty 
            });
          }
        });
      }
    },
    unselectCustomer() {
      this.$store.dispatch(`setCustomer`, '')
    },
    /**
     * Scrolls the sale-lines pane so the most recently added line is visible.
     *
     * Strategy:
     *  1. Wait for Vue's $nextTick so the new DynamicScrollerItem is mounted.
     *  2. Wait one requestAnimationFrame so the virtual scroller has measured
     *     the new item's height (vue-virtual-scroller needs a paint cycle).
     *  3. Prefer scroller.scrollToItem(lastIndex) — more reliable than
     *     scrollToBottom() for DynamicScroller with key-field="index".
     *  4. Fall back to direct el.scrollTop = el.scrollHeight.
     *
     * Always scroll on every change (no near-bottom guard). This is the
     * simplest, most predictable behavior and works on any screen size
     * regardless of how many items are visible.
     *
     * @param {number} [prevCount] - Previous line count (currently unused
     *   since we always scroll, but kept for signature compatibility).
     */
    scrollToBottom(prevCount) {
      const lines = this.$store.getters.getSaleLines || [];
      const newCount = lines.length;

      this.$nextTick(() => {
        this._nextFrame().then(() => {
          const scroller = this.$refs.saleLinesScroller;

          if (scroller && typeof scroller.scrollToItem === 'function') {
            try {
              // vue-virtual-scroller 1.x supports an optional 2nd arg for behavior.
              scroller.scrollToItem(newCount - 1, { behavior: 'auto' });
            } catch (_) {
              scroller.scrollToItem(newCount - 1);
            }
            return;
          }
          const el = scroller && scroller.$el ? scroller.$el : null;
          if (el) {
            el.scrollTop = el.scrollHeight;
          }
        });
      });
    },
    scrollToIndex(index) {
      this.$nextTick(() => {
        const scroller = this.$refs.saleLinesScroller;
        if (scroller && scroller.scrollToItem) {
          scroller.scrollToItem(index);
        } else if (scroller && scroller.$el) {
          // Fallback: approximate scroll if API is not available
          scroller.$el.scrollTop = index * 36;
        }
      });
    },
    /**
     * Resolves on the next animation frame. Used by scrollToBottom() to give
     * the virtual scroller a paint cycle to size newly inserted items before
     * we attempt to scroll to them.
     * @returns {Promise<void>}
     */
    _nextFrame() {
      return new Promise((resolve) => {
        if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
          window.requestAnimationFrame(() => resolve());
        } else {
          setTimeout(resolve, 16);
        }
      });
    },
    /**
     * Debounced scroll + localStorage save, shared by both watchers
     * (array reference and line count). 120ms debounce gives the
     * scroller time to measure virtual item heights while still
     * feeling instant to the cashier.
     * @param {Array} lines - Current sale lines (for localStorage save)
     * @param {number} [newCount] - New line count (for the near-bottom guard)
     * @param {number} [oldCount] - Previous line count
     */
    _scheduleScrollAndSave(lines, newCount, oldCount) {
      if (this._scrollTimeout) {
        clearTimeout(this._scrollTimeout);
      }
      this._scrollTimeout = setTimeout(() => {
        this.scrollToBottom(typeof oldCount === 'number' ? oldCount : undefined);
      }, 120);

      if (this._saveTimeout) {
        clearTimeout(this._saveTimeout);
      }
      this._saveTimeout = setTimeout(() => {
        try {
          localStorage.setItem('currentSaleLines', JSON.stringify(lines));
        } catch (e) {
          // localStorage may be full or unavailable in some webviews.
        }
      }, 300);
    },
    CreateVoucher() {
      this.$router.push({name: 'CreateVoucher'});
    },
    selectCustomer() {
      this.$router.push({name: 'select-customer', query: {saleNumber: this.$route.query.saleNumber}});
    },
    close() {
      this.$router.push({name: 'pos'});
    },

    checkItemOffer(item) {
      this.currentItem = item; // Track the selected item
      const hasOffer = item.offer;

      if (hasOffer) {
        this.triggerModal('openAmountInputModalButton');
      } else {
        this.triggerModal('openCustomerInformationModalButton');
      }
    },
    triggerModal(buttonId) {
      const button = document.getElementById(buttonId);
      if (button) {
        button.click();
      }
    },
    buildItemImageUrl(item) {
      const plu = item?.PLU || item?.plu;
      const defaultStore = this.$store.getters.getDefaultStore;
      const storeDb = defaultStore?.StoreDB;
      if (!plu || !storeDb) {
        return item?.Image || null;
      }

      const base = String(window.stockImageApiBase || window.franchiseTomcatApi || '').replace(/\/+$/, '/');
      if (!base) {
        return item?.Image || null;
      }

      return `${base}stock/${encodeURIComponent(storeDb)}/image?plu=${encodeURIComponent(plu)}`;
    },

    selectOption(option) {
      this.$utils.showLoading();
      this.selectedCategory = option;
      return axios.get(zedMobileApi + 'products/getByCatgeory', {
        params: {category: option},
        headers: {"Api-key": this.$store.getters.getZedMobileApiKey}
      }).then(response => {
        const items = Array.isArray(response?.data) ? response.data : [];
        this.selectedItem = items.map(item => ({
          ...item,
          Image: this.buildItemImageUrl(item),
        }));
      })
          .catch(error => errorHandler.tomcatError(error))
          .finally(() => this.$utils.hideLoading());
    },
    resetAmountInputFields() {
      this.amount = '';
      this.cell = '';
      document.getElementById("amountCloseBtn").click();
    },

    resetCustomerInfoFields() {
      this.cell = '';
      document.getElementById("closemodal").click();
    },
    handleAmountInputSave() {
      if (this.currentItem) {
        this.addToSaleWithAmount({
          ...this.currentItem,
          amount: this.amount,
          cell: this.cell,

        });
        this.resetAmountInputFields()
      }
    },

    handleCustomerInfoSave() {
      if (this.currentItem) {
        this.addToSaleWithPhoneNumber({
          ...this.currentItem,
          cell: this.cell,
        });
        this.resetCustomerInfoFields()
      }
    },
    addToSaleWithAmount(item) {
      let obj = {
        Plu: item.PLU,
        Description: item.Description,
        Qty: 1,
        Unit: item.amount,
        Line: item.amount,
        Discount: 0,
        vat: 0,
        tourismLevy: 0.0,
        instructions: [],
        voucher: true,
        cell: item.cell || "",
        offer: item.offer || "",
      };
      this.$store.commit('addToCurrentSaleLines', obj);
      this.$store.dispatch('calculateTipAmount');
    },

    addToSaleWithPhoneNumber(item) {
      let obj = {
        Plu: item.PLU,
        Description: item.Description,
        Qty: 1,
        Unit: item.SellingIncl,
        Line: item.SellingIncl,
        tourismLevy: 0,
        Discount: 0,
        vat: 0,
        instructions: [],
        voucher: true,
        offer: item.offer || "",
        cell: item.cell || "",
      };
      this.$store.commit('addToCurrentSaleLines', obj);
      this.$store.dispatch('calculateTipAmount');
    },
  },
};
</script>


<style lang="scss" scoped>
// Theme transition for smooth color changes
// Optimize: Apply transitions only to specific elements, not all (*)
.sales-panel,
.sale-header,
.sale-lines-table,
.sale-stats,
.product-card {
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

.sales-panel {
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 3px;
  background-color: var(--bg-primary);

  .sale-header {
    max-height: 45px;
    border-radius: 0;
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    margin-bottom: 5px;

    .header {
      display: flex;
      flex-direction: row;
      align-items: center;

      h2 {
        margin: 0;
        font-size: 14px;
      }

      button {
        width: 26px;
        height: 26px;
        background: var(--card-bg);
        font-size: 16px;
        color: var(--text-primary);
        padding: 0;
      }
    }
  }

  .sale-lines-table {
    flex: 1; // Grow to fill available space
    overflow: hidden; // Hide overflow, let scroller handle it
    min-height: 0; // Allow shrinking below content size
    display: flex;
    flex-direction: column;
    background: transparent;
    border: none;
    padding: 0; 
    margin: 5px; /* Add margin to separate from edges */

    .sales-list-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.2); 
      border-bottom: 2px solid rgba(255, 255, 255, 0.1);
      padding: 8px 0;
      color: var(--text-secondary);
      font-weight: 600;
      font-size: 13px;
      
      .header-cell {
        padding: 0 6px;
        text-align: left;
        
        &.stock-code-header { width: 10%; padding-left: 12px; }
        &.description-header { width: 30%; padding-left: 12px; }
        &.tax-header { width: 10%; text-align: right; padding-right: 12px;}
        &.qty-header { width: 8%; text-align: center; }
        &.discount-header { width: 10%; text-align: right; padding-right: 12px; }
        &.unit-price-header { width: 12%; text-align: right; padding-right: 12px;}
        &.total-price-header { width: 12%; text-align: right; padding-right: 12px;}
      }
    }

    .scroller {
      height: 100%;
      overflow-y: auto;
    }
    margin-bottom: 0; // Remove margin, let parent padding/gap handle spacing
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    border-radius: 12px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
    padding: 0;
    display: flex;
    flex-direction: column;
    
    @media (max-width: 768px) {
      height: 400px; // Fixed height on mobile if visible
    }

    table.sales-list-table {
      width: 100%;
      border-collapse: collapse; // Changed to collapse for better alignment
      border-spacing: 0;
      border: none;
      font-size: 13px;
      font-family: 'Montserrat', sans-serif;
      border-radius: 12px;
      overflow: hidden;
      table-layout: fixed; // Fix column widths for the entire table

      thead {
        position: sticky; // Make headers sticky
        top: 0; // Stick to the top
        z-index: 10; // Ensure headers stay on top
        background: var(--card-bg);
      }

      tbody {
        width: 100%;
      }

      th {
        background: var(--card-bg);
        color: var(--text-secondary);
        padding: 8px 12px;
        text-align: left;
        font-weight: 600;
        font-size: 14px;
        position: sticky;
        top: 0;
        z-index: 1;
        border-bottom: 2px solid var(--card-border);
        border-top: 1px solid var(--card-border);
        text-transform: uppercase;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

        @media (max-width: 1200px) {
          font-size: 13px;
          padding: 7px 10px;
        }
        @media (max-width: 992px) {
          font-size: 12px;
          padding: 6px 8px;
        }
        @media (max-width: 768px) {
          font-size: 11px;
          padding: 5px 6px;
        }
      }

      .stock-code-header {
        width: 10%;
        text-align: left;
      }

      .description-header {
        width: 25%;
        text-align: left;
      }

      .qty-header {
        width: 8%;
        text-align: center;
      }

      .unit-price-header {
        width: 12%;
        text-align: right;
        padding-right: 16px;
      }

      .tax-header {
        width: 10%;
        text-align: right;
        padding-right: 16px;
      }

      .discount-header {
        width: 10%;
        text-align: right;
        padding-right: 16px;
      }

      .total-price-header {
        width: 12%;
        text-align: right;
        padding-right: 16px;
      }

      tbody {
        tr {
          margin: 0;
          border-bottom: 1px solid var(--card-border);
          transition: background-color 0.2s ease;

          &:hover {
            background-color: rgba(var(--accent-electric-blue-rgb), 0.1);
          }

          &.selected-line {
            background-color: rgba(var(--accent-electric-blue-rgb), 0.2) !important;
            border-left: 3px solid var(--accent-electric-blue);
          }

          [data-theme='dark'] & {
            &:hover {
              background-color: rgba(var(--accent-electric-blue-rgb), 0.2);
            }

            &.selected-line {
              background-color: rgba(var(--accent-electric-blue-rgb), 0.3) !important;
            }
          }
        }
      }
    }

    .sales-list {
      list-style: none;
      padding: 0 0 130px 0;

      li {
        border: 1px solid var(--card-border);
        border-radius: 12px;
        margin-bottom: 5px;
        background: var(--card-bg);
      }
    }
  }

  .sale-stats {
    margin-top: 24px;
    position: relative; // Change to relative to be part of the flow
    flex-shrink: 0; // Prevent shrinking
    max-height: 140px; // Keep a max-height
    margin-bottom: 2px;
    bottom: 0px; // Remove fixed positioning
    left: auto; // Remove fixed positioning
    right: auto; // Remove fixed positioning
    background: var(--card-bg);
    border: var(--card-border);
    border-radius: 0;
    padding: 6px;

    @media (max-width: 768px) {
      max-height: 100px; // Adjust for smaller screens
      padding: 4px;
    }
  }
}

.list-group-item {
  font-size: 1.5rem; /* Increased font size */
  padding: 15px 20px; /* Increased padding */
}

h4, h5, h6 {
  margin: 0;
}

.example-card-img-responsive {
  width: 80px;
  height: 65px;
  margin: 10px;
  opacity: 0.8;
}

.product-card {
  height: 110px;
  transition: var(--transition-speed);
  overflow: hidden;
  width: 100%;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  word-wrap: break-word;
  background: var(--card-bg);
  border: var(--card-border);
  box-shadow: var(--card-shadow);
  margin: 4px 0; /* Add margin for better spacing */

  .product-description {
    font-weight: 600;
    color: var(--text-primary);
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.05); /* Add subtle text shadow for better readability */
    letter-spacing: -0.01em;
  }

  .product-description2 {
    font-weight: 400;
    color: var(--text-secondary);
    letter-spacing: -0.01em;
  }

  .product-price {
    font-weight: 700;
    color: var(--accent-electric-blue);
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
    letter-spacing: 0.5px;
  }

  &:hover, &:focus {
    background: var(--accent-primary);
    color: var(--primary-button-text);
    transform: scale(1.03);

    .product-description {
      color: var(--primary-button-text);
    }

    .product-price {
      color: var(--primary-button-text);
    }
  }
}

img {
  height: 94px;
  width: 94px;
  opacity: 0.7;
  border-radius: 10px;
}

.text-sm {
  font-size: 12px !important;
}

:deep(.invalid-quantity-modal) {
  .invalid-quantity-alert {
    text-align: left;
    padding: 10px 0;

    p {
      margin: 8px 0;
      font-size: 14px;
      color: var(--text-primary);
    }

    .highlight-text {
      color: var(--danger);
      font-weight: 500;
      margin: 12px 0;
    }

    .current-value {
      background: var(--card-bg);
      padding: 8px;
      border-radius: 4px;
      border-left: 3px solid var(--danger);
      color: var(--text-primary);
    }

    strong {
      color: var(--danger);
    }
  }
}

.btn {
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>
